<div class="wrapper">
    <div class="header horizontal-grid">
        <div></div>
        <div>Name des Merkmals</div>
        <div style="margin-left: 0.5em">Optional</div>
        <div></div>
    </div>
    <div *ngFor="let attr of getSortedAttributeList(); let i = index">
        <div class="horizontal-grid" [class]="i % 2 == 0 ? 'even' : 'odd'">
            <img [src]="'/assets/img/icons/info.png'" alt="Beschreibungs-Icon" [matTooltip]="
                    attr.description
                        ? attr.description
                        : 'Keine Kurzinformation vorhanden'
                " [matTooltipPosition]="'below'" matTooltipClass="tooltip" />
            <div>{{ attr.name }}</div>

            <toggle-switch id="{{ attr.id }}" [trueLabel]="'Ja'" [falseLabel]="'Nein'" [allowUndefined]="false"
                (valueChange)="onToggleOptional($event, attr.id)" [value]="isAttributeOptional(attr.id)"
                [disableToggle]="!editable"></toggle-switch>

            <div class="right">
                <mat-icon *ngIf="editable" class="delete-button" (click)="removeAttribute(attr.id)">clear</mat-icon>
            </div>
        </div>
    </div>
</div>